module.exports = __webpack_public_path__ + "media/bootstrap-icons/emoji-frown-fill-45f3cc5f.svg";